import { render, staticRenderFns } from "./PaysafeDepositLoader.vue?vue&type=template&id=0a047c4a&scoped=true"
import script from "./PaysafeDepositLoader.vue?vue&type=script&lang=js"
export * from "./PaysafeDepositLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a047c4a",
  null
  
)

export default component.exports